import { useAuth } from '../../../contexts/AuthContext';
import { RegulatoryDocsPanel } from '../../voice-agents/components/RegulatoryDocsPanel';

export function RegulatoryDocsSection() {
  const { currentOrganization } = useAuth();
  const organizationId = currentOrganization?.id ?? '';

  return <RegulatoryDocsPanel organizationId={organizationId} />;
}
